import {IContent} from "../../HubFramework"
import Files from "./Tabs/Files";
import Config from "./Tabs/Config";
import {UserRoles} from "../../Utils";
import {odxIconSets} from "../../OdxComponents/constants";

/**
 * The content of the module
 * This is mandatory for every module. It contains all the information about the module.
 */
export const moduleContent: IContent = {
    moduleName: "dpas",
    title: "Dräger Product Asset Storage (DPAS)",
    pages: [
        {
            displayName: "Files",
            contentPage: Files,
            minimumRole: UserRoles.reader,
            icon: {
                name: "folder",
                iconSet: odxIconSets.core
            },
        },
        {
            displayName: "Configuration",
            contentPage: Config,
            minimumRole: UserRoles.reader,
            icon: {
                name: "config",
                iconSet: odxIconSets.core
            },
        },
        // {
        //     displayName: "Logs",
        //     contentPage: Logs
        // }
    ],
    creationProps: [],
    defaultPage: "Files",
};
